import { AgeGroup } from '@/shared/api/protocol-ts/api/core/svc_patient_pb';

export const getAgeGroup = (
  ageGroupFilters: string[] | undefined,
): AgeGroup => {
  if (!ageGroupFilters?.length) {
    return AgeGroup.PatientListStreamAgeGroup_AllAges;
  }

  if (ageGroupFilters?.length === 1) {
    return Number(ageGroupFilters?.at(0)) as AgeGroup;
  } else if (ageGroupFilters?.length > 1) {
    // TODO: [1/m] if we have more then one age group filter then we need to return all ages, but we need to clarify this
    return AgeGroup.PatientListStreamAgeGroup_AllAges;
  }

  return AgeGroup.PatientListStreamAgeGroup_AllAges;
};
